
<div class="keys">
  @for (key of data.addKeys; track key) {

    <button type="button" class="btn btn-primary btn-lg btn-block add-key" (mousedown)="setAmaountKey(key)"
      [disabled]="key == null">
      {{ key }}
    </button>

  }
  @for (key of keys; track key) {
    <button type="button" mat-stroked-button color="accent" class="btn-block"
      (mousedown)="setAmaountKey(key)" [disabled]="key == null">
      @if (key === null) {
        {{ key }}
      }
      @if (key != 'back') {
        {{ key }}
      }
      @if (key == 'back') {
        <mat-icon>backspace</mat-icon>
      }
    </button>
  }
</div>


